// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { DateValidityComponent } from './date-validity.component';
import { DatePipeModule } from 'libraries/date/date.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        DatePipeModule,
        CommonModule,
        FontAwesomeModule,
    ],
    exports: [
        DateValidityComponent,
    ],
    declarations: [
        DateValidityComponent,
    ],
    providers: [],
})
export class DateValidityModule { }
